import { adminPaths } from "@app/routing/adminPaths";
import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useFeatureSwitch } from "@app/shared/posthog/useFeatureSwitch";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAvailableFrameworkCategories } from "../data";
import { useFrameworkTranslations } from "./i18n";

export function useFrameworkCategoryBreadcrumb() {
    const { framework_group_id } = useParams();
    const { t, keys } = useFrameworkTranslations();
    const { availableFrameworkCategories } = useAvailableFrameworkCategories();
    const experimentalEvsRedirect = useFeatureSwitch(
        "ecovadis2025BetaTesters",
        {
            devOrgUname: "airbus",
        },
    );

    const setBreadcumb = useBreadcrumb();

    useEffect(() => {
        const activatedFrameworkCategory = availableFrameworkCategories
            ? availableFrameworkCategories
                  // first get all activated frameworks only
                  .filter((cat) => cat.activated)
                  // then filter out legacy ones
                  .filter((cat) => {
                      if (cat.cmsGroupId === "csrd") {
                          return false;
                      }
                      if (cat.cmsGroupId === "evs") {
                          return experimentalEvsRedirect;
                      }
                      return true;
                  })
            : [];

        const currentFrameworkCategory = activatedFrameworkCategory?.find(
            (cat) => cat.cmsGroupId === framework_group_id,
        );

        setBreadcumb(
            adminPaths.framework_group_id_param,
            currentFrameworkCategory?.name ?? "...",
        );

        setBreadcumb(adminPaths.frameworks, t(keys.breadcrumb_frameworks));
    }, [availableFrameworkCategories, framework_group_id, t, keys]);
}
